"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = exports.Title = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CloseLargeIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseLargeIcon"));

var config = _interopRequireWildcard(require("@8x8/oxygen-config"));

var _titleAlignment = _interopRequireDefault(require("./constants/title-alignment"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CloseIcon = (0, _styledComponents["default"])(_CloseLargeIcon["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.padding;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.padding;
});
exports.CloseIcon = CloseIcon;

var Container = _styledComponents["default"].div.attrs(function (_ref3) {
  var testId = _ref3.testId;
  return Object.assign({}, config.getTestAttributes(testId));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding: ", ";\n  ", ";\n  box-shadow: ", ";\n  font-family: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.padding;
}, function (_ref5) {
  var onClose = _ref5.onClose,
      theme = _ref5.theme;
  return onClose ? "padding-right: ".concat(theme.paddingRightWithButton) : '';
}, function (_ref6) {
  var borderBottom = _ref6.borderBottom,
      theme = _ref6.theme;
  return borderBottom ? "".concat(theme.shadowSize, " ").concat(theme.shadowColor) : 'none';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
});

exports.Container = Container;

var Title = _styledComponents["default"].div.attrs(function () {
  return Object.assign({}, config.getTestAttributes('MODAL_HEADER_TITLE'));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.titleFontSize;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.titleLineHeight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.titleFontWeight;
}, function (_ref11) {
  var align = _ref11.align;
  return align;
}, (0, _polished.ellipsis)());

exports.Title = Title;
Title.propTypes = {
  alignTitle: _propTypes["default"].oneOf(Object.values(_titleAlignment["default"]))
};
Title.defaultProps = {
  alignTitle: _titleAlignment["default"].LEFT
};